<template>
	<RectangleTile background="background-transparent" class="myreward-basic-information">


		<template v-slot:icon>
			<img width="150px" :src="selectedMyPayoutData.payout_option.icon" />
		</template>



		<template v-slot:details>
			<TileDetails>
				<template v-slot:name>{{ selectedMyPayoutData.payout_option.name }}</template>
				<template v-slot:description>
					{{ selectedMyPayoutData.currency }}
					<span>
						{{ getCurrencySymbol(selectedMyPayoutData.currency) + selectedMyPayoutData.currency_amount }}
					</span>
				</template>
			</TileDetails>
		</template>



		<template v-slot:actions>
			<TileCoins :coins_amount="selectedMyPayoutData.coins_amount" />
		</template>


	</RectangleTile>
</template>



<script setup>

import { computed } from "vue";
import { PayoutStore } from "@/store/PayoutStore";
import { getCurrencySymbol } from "@/utils/utils";

import TileDetails from "@/components/Common/Tile-Details.vue";
import TileCoins from "@/components/Common/Tile-Coins.vue";
import RectangleTile from '@/components/Tiles/Rectangle-Tile.vue';

const payoutStore = PayoutStore();

const selectedMyPayoutData = computed(() => {
    return payoutStore.SelectedMyPayoutData;
});

</script>
